import { OPFSStorage } from "@/Services/OPFSStorage";

import { CatalogData, CatalogKey, CatalogMeta } from "./CatalogStorage.types";

const CATALOG_DIR = "catalog";
const CATALOG_META_FILE = "meta.json";

export class CatalogStorageFs extends OPFSStorage {
    private async catalogDir() {
        return super.getDir(CATALOG_DIR);
    }

    async write<K extends CatalogKey>(
        key: K,
        data: CatalogData[K],
    ): Promise<void> {
        const dir = await this.catalogDir();
        await this.writeJson(dir, `${key}.json`, data);
    }

    async read<K extends CatalogKey>(key: K): Promise<CatalogData[K] | null> {
        const dir = await this.catalogDir();
        return this.readJson<CatalogData[K]>(dir, `${key}.json`);
    }

    async delete(key: CatalogKey): Promise<void> {
        const dir = await this.catalogDir();
        await this.deleteFile(dir, `${key}.json`);
    }

    async saveMeta(key: CatalogKey, version: string): Promise<void> {
        const dir = await this.catalogDir();
        const existing = await this.getMeta();

        await this.writeJson<CatalogMeta>(dir, CATALOG_META_FILE, {
            ...existing,
            [key]: { version },
        });
    }

    async getMeta(): Promise<CatalogMeta | null> {
        const dir = await this.catalogDir();
        return this.readJson<CatalogMeta>(dir, CATALOG_META_FILE);
    }

    async getVersion(key: CatalogKey): Promise<string | null> {
        const meta = await this.getMeta();
        return meta?.[key]?.version ?? null;
    }
}
